import { useEffect } from 'react';

import { Button } from '@iwoca/orion';
import { useField } from 'formik';

import styles from './OnfidoButton.module.css';
import { useOnfido } from './useOnfido.hook';
import { Input } from '../../../../../../components/Input/Input';
import { InputError } from '../../../../../../components/InputError/InputError';

export const OnfidoButton = ({
  onfidoPhoneNumberName,
  onfidoStatusName,
  className,
}: {
  onfidoPhoneNumberName: string;
  onfidoStatusName: string;
  className?: string;
}) => {
  const { onfidoStatus, dispatchOnfidoCheck } = useOnfido();
  const [onfidoPhoneNumberField] = useField(onfidoPhoneNumberName);
  const isError = onfidoStatus === 'ERROR' || onfidoStatus === 'DENIED';

  const isPending = onfidoStatus === 'PENDING';
  const isApproved = onfidoStatus === 'APPROVED';

  const [, , { setValue: setOnfidoStatus }] = useField(onfidoStatusName);

  const isButtonDisabled = onfidoPhoneNumberField.value === '' || isPending;

  useEffect(() => {
    void setOnfidoStatus(onfidoStatus);
    // eslint-disable-next-line
  }, [onfidoStatus]);

  const getButtonText = (onfidoStatus: string) => {
    if (onfidoStatus === 'PENDING') return 'Verifying...';
    if (onfidoStatus === 'ERROR' || onfidoStatus === 'DENIED')
      return 'Text me again';

    return 'Text me';
  };

  return (
    <>
      <div className={styles.onfidoButtonContainer}>
        <Input
          name={onfidoPhoneNumberName}
          label="Mobile number"
          className={className}
          type="tel"
          showError={false}
        />

        {isApproved ? (
          <div className={styles.isApproved}>Approved</div>
        ) : (
          <Button
            variant="primary"
            onClick={dispatchOnfidoCheck}
            className={styles.addendumButton}
            disabled={isButtonDisabled}
          >
            {getButtonText(onfidoStatus)}
          </Button>
        )}
      </div>

      <InputError
        isVisible={isError}
        error={
          'We weren’t able to complete your check, try again or call us on 0203 778 0549'
        }
      />
    </>
  );
};
